class ComposingState {
  static value = '';

  static set(value: string) {
    ComposingState.value = value;
  }

  static get() {
    return ComposingState.value;
  }

  static reset() {
    ComposingState.value = '';
  }
}

export default ComposingState;
